import { Typography } from "@mui/material";
import React from "react";
import AvailableFinalPhase from "../AvailableFinalPhase/AvailableFinalPhase";
import FinalPhaseHeader from "../FinalPhaseHeader/FinalPhaseHeader";

const FinalPhase = () => {
  const style =
    "color: tomato; background:#eee; -webkit-text-stroke: 1px black; font-size:30px;";
  console.log("%cHi, We are Happy 😆 to have you as our Inspector", style);

  document.title = "Physics Admission Batch ~ Physics Of Stupid";
  return (
    <div>
      <FinalPhaseHeader />

      <Typography sx={{ mt: "10px", px: "4px" }} variant="body1" gutterBottom>
        আপেল এর জায়গায় নারিকেল ফেলা যাক নিউটন কাক্কুর মাথায় 🚀
      </Typography>

      <AvailableFinalPhase />
    </div>
  );
};

export default FinalPhase;
